export default {
  mounted(el) {
    el.addEventListener('click', (e) => {
      if (el.disabled) {
        e.preventDefault()
        return
      }
      el.disabled = true
      setTimeout(() => {
        el.disabled = false
      }, 1000)
    })
  }
}